import AdminEventForm from "./AdminEventForm";

const EventEdit = () => {
  return <AdminEventForm />;
};

export default EventEdit;
